import { useEffect, useState } from "react";
import axios from "axios";

const VehicleCumulativeInfo = ({ vehicleCode, vBasis }) => {
  const [cumulative, setCumulative] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCumulative = async () => {
      try {
        console.log(" Starting fetch for vehicleCode & basis:", vehicleCode, vBasis);

        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/vehicle_cumulative/${vehicleCode}/${vBasis}`);

        // console.log("API Response received:", response);
        // console.log("Response data:", response.data);

        if (!response.data || Object.keys(response.data).length === 0) {
          throw new Error("Empty data received from API.");
        }

        setCumulative(response.data);
      } catch (err) {
        console.error("API fetch error:", err);
      } finally {
        console.log(" Fetch complete");
        setLoading(false);
      }
    };

    if (vehicleCode && vBasis) {
    //   console.log("🔁 Inputs are valid. Starting fetch...");
      fetchCumulative();
    } else {
    //   console.warn("vehicleCode or vBasis is missing. Skipping fetch.");
    }
  }, [vehicleCode, vBasis]);

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <strong>{cumulative?.vBasis || vBasis || "N/A"}</strong> -{" "}
      {cumulative?.total !== undefined && cumulative?.total !== null
        ? cumulative.total
        : "No Data"}
    </div>
  );
};

export default VehicleCumulativeInfo;
